import { render, staticRenderFns } from "./roseChart.vue?vue&type=template&id=2fbc4cde"
import script from "./roseChart.vue?vue&type=script&lang=js"
export * from "./roseChart.vue?vue&type=script&lang=js"
import style0 from "./roseChart.vue?vue&type=style&index=0&id=2fbc4cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports